import { BaseAPI } from '../../BaseApi';
import { eAPITags } from '../../eAPITags';
import { CACHE_TIME } from '../../../utilities/Constants.APIConfig';

export interface MaritalStatus {
  id: string;
  label: string;
  description?: string;
}

interface NormalizedMaritalStatusData {
  maritalStatusesById: Record<string, MaritalStatus>;
  maritalStatuses: MaritalStatus[];
}
export const PartyStaticDataApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listMaritalStatuses: build.query<NormalizedMaritalStatusData, void>({
      query: () => `/timber/api/internal/marital-statuses`,
      transformResponse: (response: MaritalStatus[]) => {
        const maritalStatusesById = {};
        response.forEach((martialStatus) => {
          maritalStatusesById[martialStatus.id] = martialStatus;
        });

        return { maritalStatuses: response, maritalStatusesById };
      },
      providesTags: () => [eAPITags.MaritalStatuses],
      keepUnusedDataFor: CACHE_TIME,
    }),
  }),
  overrideExisting: false,
});

export const { useListMaritalStatusesQuery } = PartyStaticDataApi;

export const defaultNormalizedMaritalStatusData: NormalizedMaritalStatusData = {
  maritalStatusesById: {},
  maritalStatuses: [],
};
